"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("../../Grid"));
var _BulletedListItem = _interopRequireDefault(require("../BulletedListItem"));
var _types = require("../types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
## Usage

```jsx
import { BulletedList } from '@farewill/ui'

() => (
  <BulletedList>
    <BulletedList.Item />
  </BulletedList>
)
```

## Notes

`<BulletedList>` extends from `<Grid>` so can use any of the underlying `<Wrapper>`’s styling functionality.

### How to use this component

Use the list to call out important features or services offered by our products.

Do not use for lists greater than 5 items, instead use a normal bullet list or plain text.

#### Colour

Using green aligns with our colour guidance on states and semantics

Primary colour option is dark green and should be used for in most cases. It is the most accessible colour way

You can use light green if the dark green is too prominent for certain contexts. Only use light green on a white background, not paired with grey.

 */
const BulletedList = _ref => {
  let {
    children,
    headingSize = _types.BULLETED_LIST_HEADING_SIZE_DEFAULT,
    icon,
    ...props
  } = _ref;
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
    tag: "ul"
  }, props), _react.default.Children.map(children, child => /*#__PURE__*/_react.default.cloneElement(child, {
    headingSize,
    ...(child.props.icon === undefined && {
      icon
    })
  })));
};
BulletedList.Item = _BulletedListItem.default;
var _default = exports.default = BulletedList;